export const SCREEN_SIZE_SMALL = 576;
export const SCREEN_SIZE_MEDIUM = 768;
export const SCREEN_SIZE_LARGE = 992;
export const SCREEN_SIZE_X_LARGE = 1200;
export const SCREEN_SIZE_XX_LARGE = 1440;
